module.exports = __webpack_public_path__ + "static/img/anykdx.305326c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/anykdx.png
// module id = 203A
// module chunks = 0